export const compileBadgePreviewTemplate = (badgeTemplate) => {
    try {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(badgeTemplate, 'image/svg+xml');
        const parseError = svgDoc.querySelector('parsererror');
        if (parseError) {
            // eslint-disable-next-line no-console
            console.error('Invalid SVG:', parseError.textContent);
            return '';
        }
        const encodedSVG = btoa(badgeTemplate);
        return encodedSVG;
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error parsing SVG:', error);
        return '';
    }
};
